import { render, staticRenderFns } from "./Cam.vue?vue&type=template&id=2c77c42e"
import script from "./Cam.vue?vue&type=script&lang=js"
export * from "./Cam.vue?vue&type=script&lang=js"
import style0 from "./Cam.vue?vue&type=style&index=0&id=2c77c42e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports